'use strict';


export class MachineOutage {
  id: string;
  machineId: string;
  outageStartDate: Date;
  outageEndDate: Date;
  closed: boolean;

  static fromJson(dict: any): MachineOutage {
    let ret = new MachineOutage();
    return ret.fromJson(dict);
  }

  fromJson(dict: any): MachineOutage {
    this.id = dict.id;
    this.machineId = dict.machineId;
    this.closed = dict.closed;
    this.outageStartDate = dict.outageStartDate;
    this.outageEndDate = dict.outageEndDate;

    return this;
  }

  static fromJsonArray(array: any[]): MachineOutage[] {
    let ret: MachineOutage[] = [];
    array.forEach(item => {
      ret.push(MachineOutage.fromJson(item));
    });
    return ret;
  }
}


// WEBPACK FOOTER //
// ./src/app/models/machine-outage.ts